/**
 * @账号管理/角色与权限配置
 *

 */


import request from '@/utils/request'


//账号列表 (云平台)
export function userList(data) {
    return request({
        url: '/user/edu/cloud/v3/get/all/account/list',
        method: 'post',
        data: data
    })
}
//新增用户 (云平台)
export function addUser(data) {
    return request({
        url: '/user/edu/cloud/add/account',
        method: 'post',
        data: data
    })
}

//编辑用户 (云平台)
export function setUser(data) {
    return request({
        url: '/user/edu/cloud/mod/account',
        method: 'post',
        data: data
    })
}

//删除用户账号
export function deleteuser(data) {
    return request({
        url: '/user/edu/cloud/del/account',
        method: 'post',
        data: data
    })
}
// 获取区域列表下拉筛选数据
export function getarea(data) {
    return request({
        url: '/basic/edu/cloud/area/get/list',
        method: 'post',
        data: data
    })
}
// 获取区域下的学校下来筛选数据
export function getareaSchool(data) {
    return request({
        url: '/basic/edu/cloud/school/v2/get/list/byCondition',
        method: 'post',
        data: data
    })
}


// ---------- 角色---------
// 角色列表 （云平台）
export function user_list(data) {
    return request({
        url: '/user/edu/cloud/get/role/list',
        method: 'post',
        data: data
    })
}
// 新增角色 (云平台)
export function add_user_js(data) {
    return request({
        url: '/user/edu/cloud/batch/add/role',
        method: 'post',
        data: data
    })
}
// 新增角色 获取菜单栏 (云平台)
export function add_user_menu(data) {
    return request({
        url: `/user/edu/cloud/get/tier/menu?pfId=${window.g.platformCode}`,
        method: 'post',
        data: data
    })
}

//获取角色详情 （云平台）
export function user_details(data) {
    return request({
        url: '/user/edu/cloud/get/baseRole/details',
        method: 'post',
        data: data
    })
}
//编辑角色（云平台）
export function setrole(data) {
    return request({
        url: '/user/edu/cloud/mod/role',
        method: 'post',
        data: data
    })

}

// 删除角色（云平台）
export function delrole(data) {
    return request({
        url: '/user/edu/cloud/del/baseRole',
        method: 'post',
        data: {
            roleId: data
        }
    })
}
//-----------------------------



// 获取全部按钮及菜单（后台根据token查询）
export function getmenu() {
    return request({
        url: `/user/baseMenu/get/menu?type=${1}&pfId=${window.g.platformCode}`,
        method: 'get'
    })
}


// 分配角色菜单及权限按钮权限
export function menusbutton(data) {
    return request({
        url: '/user/edu/assign/Menus/button',
        method: 'post',
        data: data
    })
}

//根据角色id获取用户菜单及权限按钮
export function getroleIdmenu(roleId) {
    return request({
        url: `/user/baseMenu/get/menuButtonByRoleId?roleId=${roleId}`,
        method: 'get',

    })
}

//根据token获取权限按钮组合a:b
export function menuButtonByToken(roleId) {
    return request({
        url: `/user/edu/query/menu/button/list?pfId=${window.g.platformCode}&roleId=${roleId}`,
        method: 'get'
    })
}
//导出用户 (云平台)
export function exportEtpUser(data) {
    return request({
        url: `/user/edu/cloud/v3/export/account`,
        method: 'post',
        data: data,
        responseType: 'blob',
    })
}

// 查看用户权限
export function viewgetmenu(data) {
    return request({
        url: `/user/edu/cloud/v3/get/user/menu/auth`,
        method: 'post',
        data: data,
    })
}


//上传 (云平台-账号管理)
export function importUser(data, roleId) {
    return request({
        url: `/user/edu/cloud/import/account?roleId=${roleId}`,
        method: 'post',
        headers: { 'Content-Type': 'multipart/form-data' },
        data: data
    })
}


//校验角色是否被使用(教育)
export function roleIsUse(roleId) {
    return request({
        url: `/user/edu/check/roleIsUse`,
        method: 'post',
        data: {
            roleId: roleId
        }
    })
}


// WEBPACK FOOTER //
// ./src/api/power.js